import { useQuery } from '@tanstack/react-query';
import { fetchHealthCheckData, type HealthCheckResult } from '../services/healthcheck';
import { useMsalAuth } from './useMsalAuth';

/**
 * Hook to fetch and cache health check data from task-suite API
 */
export function useHealthCheckData() {
  const { getToken } = useMsalAuth();
  
  return useQuery<HealthCheckResult, Error>({
    queryKey: ['healthcheck'],
    queryFn: () => fetchHealthCheckData(getToken),
    // Health data is updated ~daily; refresh at most once per hour
    refetchInterval: 3_600_000,
    staleTime: 3_600_000,
    gcTime: 7_200_000,
    retry: 3,
  });
}
